import { Box, IconButton, ToggleButton } from "@wix/design-system";
import { useTranslation, useExperiments } from "@wix/fe-essentials-standalone";
import { ArrowRight, ArrowLeft, Confirm, Microphone } from "@wix/wix-ui-icons-common";
import type { FC } from "react";

interface ActionButtonsProps {
  sizeMapByElementType: any;
  toggleMicrophone: () => void;
  isListening: boolean;
  handleGenerateSiteClick: () => void;
  prompt: string;
  generatingProject: boolean;
  isMicPermissionDenied: boolean;
}

export const ActionButtons: FC<ActionButtonsProps> = ({
  sizeMapByElementType,
  toggleMicrophone,
  isListening,
  handleGenerateSiteClick,
  prompt,
  generatingProject,
  isMicPermissionDenied,
}: {
  sizeMapByElementType: any;
  toggleMicrophone: () => void;
  isListening: boolean;
  handleGenerateSiteClick: () => void;
  prompt: string;
  generatingProject: boolean;
  isMicPermissionDenied: boolean;
}) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const isForceHebrewEnabled = experiments.enabled("specs.picasso.forceHebrew");
  const ArrowIcon = isForceHebrewEnabled ? ArrowLeft : ArrowRight;

  // Show confirm button when mic permission is denied and there's a prompt
  if (isMicPermissionDenied) {
    return (
      <IconButton
        size={sizeMapByElementType.textAreaButton}
        onClick={handleGenerateSiteClick}
        disabled={generatingProject}
        data-testid="confirm-button"
        labelValue={t("landing.generate_site")}
      >
        <ArrowIcon />
      </IconButton>
    );
  }

  if (!prompt || isListening) {
    return (
      <IconButton
        size={sizeMapByElementType.textAreaButton}
        onClick={toggleMicrophone}
        data-testid="microphone-button"
        selected={isListening}
        labelValue={t("landing.start_listening")}
      >
        {isListening ? <Confirm /> : <Microphone />}
      </IconButton>
    );
  }
  return (
    <Box gap={1} direction="horizontal">
      {!isMicPermissionDenied && (
        <ToggleButton
          size={sizeMapByElementType.textAreaButton}
          onClick={toggleMicrophone}
          data-testid="microphone-button"
          selected={isListening}
          labelValue={t("landing.start_listening")}
        >
          <Microphone />
        </ToggleButton>
      )}
      <IconButton
        size={sizeMapByElementType.textAreaButton}
        onClick={handleGenerateSiteClick}
        disabled={generatingProject}
      >
        <ArrowIcon />
      </IconButton>
    </Box>
  );
};
